var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 4,
    viewBox: "0 0 6 4",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.134243 0.134243C-0.0309791 0.299465 -0.0436885 0.559445 0.0961146 0.739246L0.134243 0.782424L2.42591 3.07409C2.59113 3.23931 2.85111 3.25202 3.03091 3.11222L3.07409 3.07409L5.36576 0.782424C5.54475 0.603434 5.54475 0.313233 5.36576 0.134243C5.20054 -0.0309791 4.94055 -0.0436885 4.76075 0.0961146L4.71758 0.134243L2.75 2.10146L0.782424 0.134243C0.617202 -0.0309791 0.357221 -0.0436885 0.177421 0.0961146L0.134243 0.134243Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectDropdownArrow);
export default __webpack_public_path__ + "static/media/SelectDropdownArrow.569977fa3dfba0bb598e6298192eebe6.svg";
export { ForwardRef as ReactComponent };